import { createCloudRunAxios } from './axios';
import type { TwilioCredentialsResponse } from '../utils/twilioCredentialsCopy';

const remiApi = createCloudRunAxios('remi-api');

/**
 * Save a client's own Twilio subaccount credentials and activate Remi SMS.
 *
 * remi-api verifies the pair with Twilio before storing it and never echoes
 * the token back. Errors are rethrown untouched so the caller can read
 * `detail.code` — callers must not log the raw error, since its axios
 * `config.data` carries the auth token.
 */
export const saveTwilioCredentials = async (
  orgId: string,
  accountSid: string,
  authToken: string
): Promise<TwilioCredentialsResponse> => {
  const response = await remiApi.post<TwilioCredentialsResponse>(
    `/api/v1/organizations/${orgId}/sms/twilio-credentials`,
    { account_sid: accountSid, auth_token: authToken }
  );
  return response.data;
};
